/* GlobifySIM – Datenrechner: empfiehlt ein Datenvolumen für die Reise */
(function () {
  "use strict";

  /* Verbrauch je Reisetag in Megabyte, gerundete Erfahrungswerte */
  var PROFILE = { leicht: 250, mittel: 600, stark: 1400 };
  var HOTSPOT = 1.5;   /* Aufschlag, wenn weitere Geräte mitversorgt werden */
  var PUFFER = 1.2;    /* 20 Prozent Reserve */
  var STUFEN = [1, 2, 3, 5, 10, 15, 20, 30, 50, 100];

  function stufe(gb) {
    for (var i = 0; i < STUFEN.length; i++) {
      if (STUFEN[i] >= gb) return STUFEN[i];
    }
    return STUFEN[STUFEN.length - 1];
  }

  function rechnen(tage, profil, hotspot) {
    var t = Math.max(1, Math.min(90, parseInt(tage, 10) || 1));
    var mb = (PROFILE[profil] || PROFILE.mittel) * t;
    if (hotspot) mb *= HOTSPOT;
    mb *= PUFFER;
    var gb = mb / 1000;
    return {
      tage: t,
      roh: gb,
      empfehlung: stufe(gb),
      je_tag: Math.round((gb / t) * 100) / 100
    };
  }

  function aufbauen(wurzel) {
    var regler = wurzel.querySelector("[data-gs-tage]");
    var tageAnzeige = wurzel.querySelector("[data-gs-tage-anzeige]");
    var hotspot = wurzel.querySelector("[data-gs-hotspot]");
    var ausgabe = wurzel.querySelector("[data-gs-ergebnis]");
    var jeTag = wurzel.querySelector("[data-gs-je-tag]");
    var knopf = wurzel.querySelector("[data-gs-rechner-knopf]");
    var felder = wurzel.querySelectorAll("[data-gs-profil]");
    if (!regler || !ausgabe) return;

    var ziel = wurzel.getAttribute("data-gs-ziel") || "/collections/all";

    function aktuellesProfil() {
      for (var i = 0; i < felder.length; i++) {
        if (felder[i].checked) return felder[i].value;
      }
      return "mittel";
    }

    function aktualisieren() {
      var e = rechnen(regler.value, aktuellesProfil(), hotspot && hotspot.checked);
      ausgabe.textContent = String(e.empfehlung);
      if (tageAnzeige) tageAnzeige.textContent = String(e.tage);
      if (jeTag) jeTag.textContent = e.je_tag.toFixed(2).replace(".", ",");
      for (var i = 0; i < felder.length; i++) {
        var kasten = felder[i].closest(".gs-wahl__feld");
        if (kasten) kasten.classList.toggle("ist-aktiv", felder[i].checked);
      }
      if (knopf) {
        var trenn = ziel.indexOf("?") >= 0 ? "&" : "?";
        knopf.setAttribute("href", ziel + trenn + "gb=" + e.empfehlung + "&tage=" + e.tage);
      }
    }

    regler.addEventListener("input", aktualisieren);
    if (hotspot) hotspot.addEventListener("change", aktualisieren);
    for (var i = 0; i < felder.length; i++) felder[i].addEventListener("change", aktualisieren);
    aktualisieren();
  }

  window.GSRechner = { rechnen: rechnen, stufe: stufe, PROFILE: PROFILE };

  document.addEventListener("DOMContentLoaded", function () {
    var alle = document.querySelectorAll("[data-gs-rechner]");
    for (var i = 0; i < alle.length; i++) aufbauen(alle[i]);
  });
})();
